import { render, staticRenderFns } from "./TicketListItem.vue?vue&type=template&id=35a98b6b&"
import script from "./TicketListItem.vue?vue&type=script&lang=js&"
export * from "./TicketListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports